$(document).ready(function(){
  // trusted list slider
  $('.trusted-list-slider').slick({
    // dots: false,
    // arrows: false,
    // infinite: true,
    // speed: 300,
    // centerMode: true,
    // centerPadding: "100px",
    // slidesToShow: 3,
    // slidesToScroll: 1,
    speed: 14000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          // infinite: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          centerMode: false,
          centerPadding: "0px",
          slidesToScroll: 1,
          // infinite: false,
          arrows: false,
          prevArrow: '<div class="trusted-prev slick-prev"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2749 0.713867L2.30255 12.8258L13.8825 24.6539" stroke="white" stroke-width="2"/></svg></div>',
          nextArrow: '<div class="trusted-next slick-next"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.30225 0.713867L13.2746 12.8258L1.69468 24.6539" stroke="white" stroke-width="2"/></svg></div>',
        }
      }
    ]
  });

  // faq functionality
  $('.accordion_tile').click(function(e) {
    e.preventDefault();
    var $currentHeader = $(this);
    var $currentBody = $currentHeader.next('.accordion__body');
  
    var currentIsActive = $currentHeader.hasClass('is-active');
  
    $('.accordion_tile').removeClass('is-active');
    $('.accordion__body').removeClass('is-active');
  
    if (!currentIsActive) {
      $currentHeader.addClass('is-active');
      $currentBody.addClass('is-active');
    }
  });

  // video list slider
  $('.video-list-slider').slick({
    dots: false,
    arrows: true,
    infinite: false,
    appendArrows: '.video-arrows',
    slidesToShow: 4,
    prevArrow: '<div class="slick-prev"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2749 0.713867L2.30255 12.8258L13.8825 24.6539" stroke="white" stroke-width="2"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.30225 0.713867L13.2746 12.8258L1.69468 24.6539" stroke="white" stroke-width="2"/></svg></div>',
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  });

  // ambassador-slider
  $('.ambassador-slider').slick({
    dots: false,
    arrows: true,
    prevArrow: '<div class="slick-prev"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2749 0.713867L2.30255 12.8258L13.8825 24.6539" stroke="white" stroke-width="2"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.30225 0.713867L13.2746 12.8258L1.69468 24.6539" stroke="white" stroke-width="2"/></svg></div>',
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });

  // marquee-slider
  $('.marquee-slider').slick({
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  // signature trust/ambassador cards slider (mobile)
  function getSignatureCenterPadding($slider) {
    var viewport = $(window).width();
    var containerWidth = Math.round($slider.closest('.page-width').innerWidth() || viewport);
    var targetWidth;
    var padding;

    // Explicit requirement: around 485px at ~725 viewport, then scale down.
    if (viewport <= 749) {
      // Mobile: keep cards visually dominant with only a slight side-peek.
      targetWidth = Math.min(485, Math.round(viewport * 0.86));
      targetWidth = Math.max(300, targetWidth);
    } else {
      // Tablet/desktop gallery mode: make the first gallery state
      // noticeably wider so quote text doesn't feel cramped.
      targetWidth = Math.min(520, Math.round(containerWidth * 0.5));
      targetWidth = Math.max(420, targetWidth);
    }

    padding = Math.round((containerWidth - targetWidth) / 2);
    return Math.max(12, padding) + 'px';
  }

  function initSignatureCardsSlider($slider, opts) {
    if (!$slider || !$slider.length || $slider.hasClass('slick-initialized')) return;
    var options = opts || {};

    $slider.addClass('better-signature-proof__cards--gallery');

    $slider.slick({
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: options.centerPadding || getSignatureCenterPadding($slider),
      speed: 650,
      autoplay: true,
      autoplaySpeed: 10000,
      pauseOnHover: false,
      pauseOnFocus: false,
      touchThreshold: 12
    });

    // Pause while user is interacting with touch/mouse down.
    $slider
      .off('.signatureTouchPause')
      .on('touchstart.signatureTouchPause mousedown.signatureTouchPause pointerdown.signatureTouchPause', function () {
        $slider.slick('slickPause');
      })
      .on('touchend.signatureTouchPause touchcancel.signatureTouchPause mouseup.signatureTouchPause pointerup.signatureTouchPause mouseleave.signatureTouchPause', function () {
        $slider.slick('slickPlay');
      });
  }

  function destroySignatureCardsSlider($slider) {
    if (!$slider || !$slider.length || !$slider.hasClass('slick-initialized')) return;
    $slider.slick('unslick');
    $slider.removeClass('better-signature-proof__cards--gallery');
  }

  function signatureCardsNeedSlider($cards) {
    // Force slider on narrow/mobile widths.
    if ($(window).width() <= 749) return true;
    // Never use gallery on large desktop widths.
    if ($(window).width() >= 1000) return false;
    if (!$cards || !$cards.length) return false;

    var $items = $cards.children('.better-signature-proof__card');
    if ($items.length <= 1) return false;

    var firstTop = $items.first()[0].offsetTop;
    var wraps = false;
    $items.each(function () {
      if (this.offsetTop !== firstTop) {
        wraps = true;
        return false;
      }
    });

    // If cards would wrap to another row, switch to gallery mode.
    return wraps;
  }

  function syncSignatureCardsSlider() {
    $('.better-signature-proof__cards').each(function () {
      var $slider = $(this);
      var viewport = $(window).width();
      var isInit = $slider.hasClass('slick-initialized');
      var shouldInit;
      var initOptions = {};
      var switchWidth;
      var allowExit;

      if (isInit) {
        $slider.slick('slickSetOption', 'centerPadding', getSignatureCenterPadding($slider), true);

        // Exit gallery on large desktop or after significant width expansion.
        switchWidth = Number($slider.data('signatureSwitchWidth')) || 0;
        allowExit = viewport >= 1000 || (switchWidth && viewport >= (switchWidth + 120));
        if (!allowExit) return;

        destroySignatureCardsSlider($slider);
        isInit = false;
      }

      shouldInit = signatureCardsNeedSlider($slider);

      if (!shouldInit) {
        $slider.removeClass('better-signature-proof__cards--gallery');
        $slider.removeData('signatureSwitchWidth');
        return;
      }

      $slider.data('signatureSwitchWidth', viewport);
      initOptions.centerPadding = getSignatureCenterPadding($slider);
      initSignatureCardsSlider($slider, initOptions);
    });
  }

  syncSignatureCardsSlider();

  // review mobile slider
  var reviewPrevArrow = '<div class="slick-prev"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2749 0.713867L2.30255 12.8258L13.8825 24.6539" stroke="white" stroke-width="2"/></svg></div>';
  var reviewNextArrow = '<div class="slick-next"><svg width="15" height="26" viewBox="0 0 15 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.30225 0.713867L13.2746 12.8258L1.69468 24.6539" stroke="white" stroke-width="2"/></svg></div>';

  function initReviewSlider() {
    var $slider = $('.mobile-review-slider');
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;

    $slider.slick({
      arrows: true,
      dots: false,
      prevArrow: reviewPrevArrow,
      nextArrow: reviewNextArrow,
      infinite: true,
      centerMode: true,
      cssEase: 'ease-in-out',
      centerPadding: '80px',
      speed: 650,
      slidesToShow: $(window).width() <= 430 ? 1 : 2,
      slidesToScroll: 1
    });
  }

  function syncReviewSlider() {
    var $slider = $('.mobile-review-slider');
    if (!$slider.length) return;

    if ($(window).width() <= 768) {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
      initReviewSlider();
    } else if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  syncReviewSlider();
  $(window).on('resize', function () {
    syncSignatureCardsSlider();
    syncReviewSlider();
  });
});

// ── Announcement bar: hidden on load, scroll-triggered, clickable ──
$(document).ready(function () {
  var bar = document.querySelector('.announcement-bar-section');
  var hero = document.querySelector('.top-index-img-with-text');
  if (!bar) return;

  // Click anywhere on bar → offer page
  var offerUrl = '/products/better-coffee-booster-enhanced-offer';
  bar.addEventListener('click', function (e) {
    if (!e.target.closest('a')) window.location.href = offerUrl;
  });

  // Hide bar immediately — nav sits flush at top on page load
  bar.classList.add('announcement--hidden');

  var shown = false;

  function onScroll() {
    var scrollY = window.scrollY || window.pageYOffset;

    // Back at very top: restore normal in-flow position above nav
    if (scrollY === 0) {
      bar.style.transition = 'none';
      bar.classList.remove('announcement--hidden', 'announcement--fixed', 'announcement--visible');
      requestAnimationFrame(function () { bar.style.transition = ''; });
      shown = false;
      return;
    }

    // Trigger at 75% through hero
    var trigger = hero
      ? hero.offsetTop + hero.offsetHeight * 0.75
      : window.innerHeight * 0.75;

    if (!shown && scrollY >= trigger) {
      shown = true;
      bar.classList.remove('announcement--hidden');
      bar.classList.add('announcement--fixed');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bar.classList.add('announcement--visible');
        });
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
});

// KaChing bundle colours — replace orange with Better brand colours.
// KaChing injects a <style> block with CSS custom properties, so we override
// those properties on the container once it becomes visible.
// Highlighted/selected → Porsche #AF8E70
// Not highlighted → Crema #E6DAC5
$(document).ready(function () {
  var ORANGE_RE = /rgba?\(\s*222\s*,\s*100\s*,\s*15\s*(?:,\s*([\d.]+))?\s*\)/g;
  var busy = false;

  function replaceOrange(str) {
    return str.replace(ORANGE_RE, function (_, a) {
      var alpha = (a !== undefined) ? parseFloat(a) : 1;
      // Solid/border (alpha >= 0.6) → Porsche; semi-transparent bg → Crema
      if (alpha >= 0.6) return 'rgba(175, 142, 112, ' + alpha + ')';
      return 'rgba(230, 218, 197, ' + alpha + ')';
    });
  }

  function patchEl(el) {
    if (!el || !el.getAttribute) return;
    var s = el.getAttribute('style');
    if (s && s.indexOf('222') !== -1) {
      var next = replaceOrange(s);
      if (next !== s) { busy = true; el.setAttribute('style', next); busy = false; }
    }
  }

  function patchStyleTags() {
    document.querySelectorAll('style').forEach(function (tag) {
      if (tag.textContent.indexOf('222, 100, 15') === -1) return;
      if (tag.dataset.kcPatched) return;
      tag.textContent = replaceOrange(tag.textContent);
      tag.dataset.kcPatched = '1';
    });
  }

  function patchAll() {
    patchStyleTags();
    document.querySelectorAll('[style]').forEach(function (el) {
      if (el.getAttribute('style').indexOf('222') !== -1) patchEl(el);
    });
  }

  // MutationObserver — catches DOM changes
  var obs = new MutationObserver(function (mutations) {
    if (busy) return;
    var needsScan = false;
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'style') {
        patchEl(m.target);
      } else if (m.addedNodes.length) {
        needsScan = true;
      }
    });
    if (needsScan) patchAll();
  });

  obs.observe(document.body, {
    childList: true, subtree: true,
    attributes: true, attributeFilter: ['style']
  });

  // Repeated scan for the first 5 seconds to catch async renders
  patchAll();
  var attempts = 0;
  var interval = setInterval(function () {
    patchAll();
    if (++attempts >= 10) clearInterval(interval);
  }, 500);
});
